import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { ErrorService } from './error.service';

import { Timezone } from './../models/timezone';

@Injectable()
export class TimezoneService {

  private url = CommonService.getEwdApiURL() + 'timezone';

  constructor(
    private http: Http,
    private errorService: ErrorService
  ) { }

  getTimezones(): Observable<Timezone[]> {
        return this.http.get(this.url)
            .map((response: Response) => response.json())
            .catch(this.errorService.handleError);
  }
}
